import React from 'react';
import { ADMIN_PAGES_KEYS } from '../../../../../i18n/constants/keys';
import {
  AlignLeftIcons,
  ChartIcons,
  FileDownIcons,
  FilePlusIcons,
  MegaPhoneIcons,
  ShieldIcons,
  SlidersHorizontalIcons,
  SquareCheckIcons,
  StarIcons,
} from '../../../../../icons/icons';
import { jobOpeningDetailsTabs, jobOpeningTypes } from '../../../../../utils/types/JobOpenings';

export interface ISidebarDefinition {
  value: jobOpeningDetailsTabs;
  labelKey: string;
  Icon: React.ComponentType<{ className?: string; size?: number | string; style?: React.CSSProperties }>;
  requiredElement?: jobOpeningTypes | 'CCA';
}

export const SIDEBAR_NAV_ITEMS: ISidebarDefinition[] = [
  {
    value: 'Job Requisition',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.sidebar.jobRequisition,
    Icon: FilePlusIcons,
  },
  {
    value: 'Job Description',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.sidebar.jobDescription,
    Icon: AlignLeftIcons,
  },
  {
    value: 'Auto Suitability',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.sidebar.autoSuitability,
    Icon: SquareCheckIcons,
    requiredElement: 'Auto-Suitability',
  },
  {
    value: 'Auto Outstanding',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.sidebar.autoOutstanding,
    Icon: StarIcons,
    requiredElement: 'Auto-Outstanding',
  },
  {
    value: 'Auto Assess Questions',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.sidebar.autoAssessQuestions,
    Icon: SlidersHorizontalIcons,
    requiredElement: 'Auto-Assessments',
  },
  {
    value: 'Job Posting',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.sidebar.jobPosting,
    Icon: MegaPhoneIcons,
    requiredElement: 'Job Posting',
  },
  {
    value: 'CV Ingestion',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.sidebar.cvIngestion,
    Icon: FileDownIcons,
    requiredElement: 'Applicant Analysis',
  },
  {
    value: 'CCA Questions',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.sidebar.ccaQuestions,
    Icon: ChartIcons,
    requiredElement: 'CCA',
  },
  {
    value: 'Permissions',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.sidebar.permissions,
    Icon: ShieldIcons,
  },
];

